import { useMemo } from "react";

import TriggeredByFlows from "components/TriggeredByFlows";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { isFlowsTrigger } from "utils/flows";
import { StackTaskRun } from "shared/Stack/useSearchTasks/gql";

import { STACK_TASKS_COLUMN_ID } from "../constants";
import useCellCopyAction from "../useCellCopyAction";

const StackTasksTableTriggeredByCell = ({
  item: task,
  ...cellProps
}: TableSimpleCellProps<StackTaskRun>) => {
  const triggeredBy = task.triggeredBy || "";
  const isFlows = isFlowsTrigger(triggeredBy);

  const copyAction = useCellCopyAction({
    column: STACK_TASKS_COLUMN_ID.TRIGGERED_BY,
    text: triggeredBy,
  });

  const actions = useMemo(
    () => (triggeredBy ? [copyAction] : undefined),
    [copyAction, triggeredBy]
  );

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isFlows && <TriggeredByFlows triggeredBy={triggeredBy} />}
      {!isFlows && <TableCellText>{triggeredBy}</TableCellText>}
    </TableSimpleCell>
  );
};

export default StackTasksTableTriggeredByCell;
